import { useTranslation } from 'react-i18next'

import { useGuideTooltip } from 'shared/hooks/use-guide-tooltip'
import { JoyrideTour } from 'shared/ui/joyride-tour'

import { createCreateObjectEntryHintSteps } from '../../lib/create-create-object-entry-hint-steps'

const COOKIE_KEY = 'kyrgyzstan_create_object_entry_hint'
const BUTTON_BORDER_RADIUS = 20

export const CreateObjectEntryHintTour = () => {
  const { t } = useTranslation()
  const content = t('kyrgyzstan_block.create_object.entry.hint')
  const steps = createCreateObjectEntryHintSteps(content)

  const { run, locale, handleCallback } = useGuideTooltip({
    steps,
    cookieKey: COOKIE_KEY,
    localeKeys: {
      last: 'kyrgyzstan_block.create_object.entry.hint_ok',
    },
  })

  return (
    <JoyrideTour
      steps={steps}
      run={run}
      onCallback={handleCallback}
      locale={locale}
      styles={{
        spotlight: {
          borderRadius: BUTTON_BORDER_RADIUS,
        },
      }}
    />
  )
}
